<template>
  <v-dialog v-model="vendorDetailDialog" persistent fullscreen>
    <template v-slot:activator="{ attrs }">
      <p id="vendorDetail" v-bind="attrs" @click="openVendorDetailDialog"></p>
    </template>
    <div
      v-if="!loading"
      style="padding: 0; margin: auto; border-radius: 5px; background: white"
    >
      <v-card
        tile
        flat
        style="
          border-bottom: 2px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          position: sticky;
          top: 0;
          background: white;
          z-index: 5;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
          "
        >
          <v-toolbar-title class="overline">
            <p
              :style="`font-size:${
                wWidth > 780 ? '20px' : '3vw'
              }; margin: 0; padding-left: 5px;`"
            >
              DETAIL VENDOR
            </p>
            <v-btn
              style="position: absolute; top: 5px; right: 20px"
              x-small
              text
              color="grey darken-2"
              @click="closeDetailVendorDialog"
            >
              <v-icon small>mdi-arrow-left</v-icon> Kembali
            </v-btn>
          </v-toolbar-title>
        </div>
      </v-card>
      <div v-if="form != null" style="min-height: 70vh">
        <v-stepper class="elevation-0" non-linear>
          <v-stepper-header>
            <v-stepper-step :complete="stepperElement > 1" step="1" editable>
              Profil
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepperElement > 2" step="2" editable>
              Kontak PIC
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepperElement > 6"
              step="3"
              editable
              v-if="
                getUserProfile.level.find(
                  ({ id }) => id == '1' || id == '3'
                ) !== undefined
              "
            >
              Finance (Pembayaran)
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepperElement > 4" step="4" editable>
              Produk/Jasa
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepperElement > 5" step="5" editable>
              Pengalaman
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepperElement > 6"
              step="6"
              editable
              v-if="
                getUserProfile.level.find(
                  ({ id }) => id == '1' || id == '3'
                ) !== undefined
              "
            >
              Dokumen
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form lazy-validation :disabled="loading" readonly>
                <v-card elevation="0" style="min-height: 75vh">
                  <v-row style="padding: 15px" :no-gutters="!isEdit">
                    <!-- <v-col cols="12" md="9" style="padding: 0"></v-col> -->
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <v-img
                            v-if="result"
                            height="150"
                            aspect-ratio="1.7"
                            contain
                            cols="12"
                            lazy-src
                            :src="`${result.urlPath}${result.logo}`"
                            alt="Company Image: undetected"
                          >
                          </v-img>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="8" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nama Perusahaan *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Kode Vendor
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.code"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Jenis Usaha *
                          </p>
                        </v-col>
                        <v-col
                          cols="12"
                          style="
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-bottom: 0;
                          "
                        >
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :value="
                              form.business_entity != null
                                ? form.business_entity.name
                                : ''
                            "
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Skala Perusahaan *
                          </p>
                        </v-col>
                        <v-col
                          cols="12"
                          style="
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-bottom: 0;
                          "
                        >
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="form.company_scale"
                            :items="dropdown.companyScale"
                            style="margin: 0"
                            item-text="name"
                            item-value="id"
                            return-id
                            dense
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Tahun Berdiri
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            type="number"
                            v-model="form.year_founded"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Alamat Kantor *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-textarea
                            @keydown.enter.prevent
                            dense
                            auto-grow
                            rows="1"
                            v-model="form.address"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Provinsi *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :value="
                              form.province != null ? form.province.name : ''
                            "
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Kota *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :value="form.city != null ? form.city.name : ''"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Kode Pos *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.zip_code"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="6" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Lat
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.location_lat"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="6" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            lng
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.location_long"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            No. Telepon 1 *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            type="number"
                            v-model="form.phone1"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            No. Telepon 2
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            type="number"
                            v-model="form.phone2"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Email *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.email"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Website (jika ada)
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.website"
                          />
                        </v-col>
                      </div>
                    </v-col>

                    <!--  -->
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Klasifikasi *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :value="
                              form.classification != null
                                ? form.classification.name
                                : ''
                            "
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Sub-Klasifikasi
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :value="
                              form.sub_classification != null
                                ? form.sub_classification.name
                                : ''
                            "
                          />
                        </v-col>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Rata-rata omset perusahaan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="form.average_turnover"
                            :items="dropdown.averageTurnover"
                            style="margin: 0"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Wilayah cakupan layanan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="form.service_coverage"
                            :items="dropdown.serviceCoverage"
                            style="margin: 0"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                            small-chips
                            deletable-chips
                            multiple
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            PKP / NON PKP
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-radio-group
                            @keydown.enter.prevent
                            v-model="form.is_pkp"
                            style="height: 45px; position: relative; top: -10px"
                          >
                            <div
                              class="d-flex justify-content-around align-content-between"
                            >
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="true"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">PKP</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                  margin-left: 40px;
                                "
                              >
                                <v-radio
                                  :value="false"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">
                                  NON PKP
                                </p>
                              </div>
                            </div>
                          </v-radio-group>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Jumlah Karyawan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="form.current_employee"
                            :items="dropdown.currentEmployee"
                            style="margin: 0"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Jumlah produk / SKU / Lini Bisinis
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="form.number_products"
                            :items="dropdown.numberProducts"
                            style="margin: 0"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="8" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Profil Perusahaan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-textarea
                            @keydown.enter.prevent
                            dense
                            auto-grow
                            rows="3"
                            v-model="form.about"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <v-row no-gutters>
                        <v-col
                          cols="4"
                          style="padding: 0; align-content: center"
                        >
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Online Shop ?
                          </p>
                        </v-col>
                        <v-col cols="8" style="padding: 0">
                          <v-switch
                            v-model="form.is_onlineshop"
                            inset
                            color="success"
                            style="margin-left: 25px"
                            readonly
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <div
                    v-if="detailData != null"
                    class="d-flex justify-center align-center card-title-div2"
                    :style="`${statusColor(detailData.review_status)};`"
                  >
                    <p class="card-title-div2-name">
                      {{ statusName(detailData.review_status) }}
                    </p>
                  </div>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-form lazy-validation :disabled="loading" readonly>
                <v-card elevation="0" style="min-height: 75vh">
                  <v-row style="padding: 15px" no-gutters>
                    <v-col cols="12" md="6">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nama PIC *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.cp_name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Jabatan / Department
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-autocomplete
                            v-model="form.cp_position"
                            :items="[
                              'Sales / Marketing / Account Manager',
                              'Sales Support',
                              'Teknik',
                              'Manager',
                              'Direktur'
                            ]"
                            style="margin: 0"
                            dense
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nomor Tlp. PIC *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            type="number"
                            v-model="form.cp_phone"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Email *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.cp_email"
                          />
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-content
              step="3"
              v-if="
                getUserProfile.level.find(
                  ({ id }) => id == '1' || id == '3'
                ) !== undefined
              "
            >
              <v-form lazy-validation :disabled="loading" readonly>
                <v-card elevation="0" style="min-height: 75vh">
                  <v-row style="padding: 15px" no-gutters>
                    <v-col cols="12" md="6">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nama Finance *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.finance_name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nomor Finance *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            type="number"
                            v-model="form.finance_phone"
                          />
                        </v-col>
                      </div>
                    </v-col>

                    <v-col cols="12" md="4">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            No. Rekening *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.finance_account_no"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Bank *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :value="form.finance_bank_name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            KCU
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.finance_bank_kcu"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Atas Nama *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            v-model="form.finance_account_name"
                          />
                        </v-col>
                      </div>
                    </v-col>

                    <v-col cols="12" md="8">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Metode Pembayaran *
                          </p>
                        </v-col>
                        <v-col
                          cols="12"
                          style="
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-bottom: 0;
                          "
                        >
                          <v-radio-group
                            @keydown.enter.prevent
                            v-model="form.payment_method"
                            style="
                              width: 100%;
                              height: 30px;
                              position: relative;
                              top: -10px;
                            "
                          >
                            <div
                              class="d-flex justify-content-between align-content-between"
                            >
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="1"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">Cash</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="2"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">CBD</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="3"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">TOP</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="4"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">
                                  Lain-lain
                                </p>
                              </div>
                            </div>
                          </v-radio-group>
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-form lazy-validation :disabled="loading" readonly>
                <v-card elevation="0" style="min-height: 75vh">
                  <v-row style="padding: 15px" no-gutters>
                    <v-col cols="12">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Deskripsi produk / jasa yang ditawarkan *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <div>
                            <div
                              v-if="form.product_description"
                              v-html="form.product_description"
                              style="
                                padding: 15px;
                                border: 1px solid rgba(0, 0, 0, 0.1);
                              "
                            ></div>
                            <v-card
                              v-else
                              flat
                              height="30vh"
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-toolbar-title class="overline">
                                Data Not Found</v-toolbar-title
                              >
                            </v-card>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="5">
              <v-form lazy-validation :disabled="loading" readonly>
                <v-card elevation="0" style="min-height: 75vh">
                  <v-row style="padding: 15px" no-gutters>
                    <v-col cols="12">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Jelaskan engalaman anda dalam menyediakan barang /
                            jasa yang sejenis *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <div>
                            <div
                              v-if="form.experience"
                              v-html="form.experience"
                              style="
                                padding: 15px;
                                border: 1px solid rgba(0, 0, 0, 0.1);
                              "
                            ></div>
                            <v-card
                              v-else
                              flat
                              height="30vh"
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-toolbar-title class="overline">
                                Data Not Found</v-toolbar-title
                              >
                            </v-card>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-content
              step="6"
              v-if="
                getUserProfile.level.find(
                  ({ id }) => id == '1' || id == '3'
                ) !== undefined
              "
            >
              <v-form lazy-validation :disabled="loading" readonly>
                <v-card elevation="0" style="min-height: 75vh">
                  <v-row style="padding: 15px" no-gutters>
                    <v-col cols="12">
                      <v-data-table
                        :headers="documentHeaders"
                        :items="form.documents"
                        hide-default-footer
                        class="elevation-1"
                        style="cursor: pointer"
                        dense
                      >
                        <template v-slot:[`item.no`]="{ index }">
                          <div style="width: 35px; font-size: 12px">
                            {{ index + 1 }}
                          </div>
                        </template>
                        <template v-slot:[`item.document_type`]="{ item }">
                          <div
                            class="d-flex justify-start align-center"
                            style="height: 45px; font-size: 12px"
                          >
                            <p style="padding: 0; margin: 0">
                              {{ item.document_type.name }}
                            </p>
                          </div>
                        </template>
                        <template v-slot:[`item.document_no`]="{ item }">
                          <div
                            class="d-flex justify-start align-center"
                            style="height: 45px; font-size: 12px"
                          >
                            <p style="padding: 0; margin: 0">
                              {{ item.document_no }}
                            </p>
                          </div>
                        </template>
                        <!-- <template v-slot:[`item.date`]="{ item }">
                          <div
                            class="d-flex justify-start align-center"
                            style="width: 80px; height: 45px; font-size: 12px"
                          >
                            <p style="padding: 0; margin: 0">{{ item.date }}</p>
                          </div>
                        </template>
                        <template v-slot:[`item.expire_date`]="{ item }">
                          <div
                            class="d-flex justify-start align-center"
                            style="width: 80px; height: 45px; font-size: 12px"
                          >
                            <p style="padding: 0; margin: 0">
                              {{ item.expire_date }}
                            </p>
                          </div>
                        </template> -->
                        <template v-slot:[`item.file`]="{ item }">
                          <v-tooltip bottom color="grey">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-if="item.file != null"
                                v-bind="attrs"
                                v-on="on"
                                small
                                text
                                icon
                                color="grey darken-2"
                                @click.stop="selectFile(item)"
                              >
                                <v-icon small>mdi-file-download</v-icon>
                              </v-btn>
                              <v-icon v-bind="attrs" v-on="on" v-else small
                                >mdi-minus</v-icon
                              >
                            </template>
                            <span v-if="item.file != null">Lihat file</span>
                            <span v-else small>File tidak tersedia</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                          <div
                            v-if="
                              item.document_type != null &&
                              item.document_type.name == 'OTHER'
                            "
                            class="d-flex justify-start align-center"
                            style="
                              min-width: 170px;
                              height: 25px;
                              font-size: 12px;
                              padding-top: 15px;
                            "
                          >
                            <v-autocomplete
                              :value="item.combined_file_type"
                              :items="dropdown.documentType"
                              multiple
                              item-text="name"
                              item-value="id"
                              hide-no-data
                              return-object
                              style="margin: 0; font-size: 10px"
                              small-chips
                              dense
                              flat
                              readonly
                            />
                          </div>
                          <div
                            v-else
                            class="d-flex justify-start align-center"
                            style="width: 160px; height: 45px; font-size: 12px"
                          >
                            <p style="padding: 0; margin: 0">
                              {{ item.description }}
                            </p>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
                <v-dialog
                  v-model="pdfDialog"
                  width="90%"
                  @click:outside="closePdfDialog"
                >
                  <v-card style="position: relative; width: 100%; height: 90vh">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          @click.prevent="closePdfDialog"
                          v-bind="attrs"
                          v-on="on"
                          text
                          icon
                          color="white"
                          style="
                            position: fixed;
                            top: 10px;
                            right: 10px;
                            z-index: 3;
                            filter: drop-shadow(1px 1px 1px white);
                          "
                        >
                          <v-icon color="red">mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Close</span>
                    </v-tooltip>
                    <div
                      id="loader"
                      class="d-flex justify-center align-center"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                      "
                    >
                      <v-progress-circular
                        v-if="isPdfOpen && pdfConverted !== ''"
                        :rotate="-90"
                        :size="150"
                        :width="15"
                        :value="value"
                        color="black"
                      >
                        {{ value / 10 }}%
                      </v-progress-circular>
                    </div>
                    <div v-if="showPdf" style="height: 100%; padding: 5px 0">
                      <vue-pdf-app
                        v-if="pdfConverted != null"
                        @pages-rendered="pagesRendered"
                        @open="openHandler"
                        :config="pdfConfig"
                        :pdf="pdfConverted"
                      >
                        <template #toolbar-sidebar-prepend="{ toggleTheme }">
                          <button @click="toggleTheme = null" type="button">
                            Toggle theme
                          </button>
                        </template>
                      </vue-pdf-app>

                      <div
                        v-else
                        class="d-flex justify-center align-center"
                        style="
                          height: 100%;
                          width: 100%;
                          margin-left: auto;
                          position: relative;
                          z-index: 1;
                          background: #eaeaea;
                        "
                      >
                        <h3 style="margin: 0">File Not Found</h3>
                      </div>
                    </div>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="imageDialog" persistent>
                  <div style="position: relative">
                    <v-btn
                      style="
                        position: absolute;
                        z-index: 1;
                        top: 10px;
                        right: 10px;
                        font-weight: bolder;
                      "
                      fab
                      x-small
                      color="black"
                      @click="closePdfDialog"
                    >
                      <v-icon color="white">mdi-close</v-icon>
                    </v-btn>

                    <div
                      style="
                        margin: auto;
                        height: 600px;
                        width: 800px;
                        position: relative;
                      "
                    >
                      <v-img
                        contain
                        :style="`
                          position: relative;
                          width: ${image.width}px;
                          height: ${image.height}px;
                          transform: rotate(${image.deg}deg) ${image.translate};
                      transform-origin: ${image.origin};`"
                        :src="
                          pdfUrl != ''
                            ? pdfUrl
                            : 'https://e-sanqua.sanquawater.co.id/image/ecatalogue/products/photo_1/ProductPhoto-jahsors8yollrrbjwsyx7.png'
                        "
                        @error="imgError"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <div
                        v-if="pdfUrl != ''"
                        class="d-flex justify-center align-center"
                        style="position: absolute; bottom: 10px; left: 360px"
                      >
                        <v-tooltip bottom color="grey">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="rotateImage('left')"
                              v-bind="attrs"
                              v-on="on"
                              style="
                                font-weight: bolder;
                                margin-right: 5px;
                                background-color: rgba(255, 255, 255, 0.8);
                              "
                              fab
                              x-small
                              color="white"
                            >
                              <v-icon color="black">mdi-rotate-left</v-icon>
                            </v-btn>
                          </template>
                          <span>rotate left</span>
                        </v-tooltip>
                        <v-tooltip bottom color="grey">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="rotateImage('right')"
                              v-bind="attrs"
                              v-on="on"
                              style="
                                font-weight: bolder;
                                background-color: rgba(255, 255, 255, 0.8);
                              "
                              fab
                              x-small
                            >
                              <v-icon color="black">mdi-rotate-right</v-icon>
                            </v-btn>
                          </template>
                          <span>rotate right</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </v-dialog>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
        z-index: 99;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.9);
      "
    >
      <v-progress-circular :size="150" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios'
import buildType from '../../../services/buildType'
import { mapGetters } from 'vuex'
import 'vue-pdf-app/dist/icons/main.css'
// import bankJson from '../../../assets/json/bank.json'
// const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'vendorDetailDialog',
  components: {},
  props: ['result'],
  data() {
    return {
      procApi: buildType.apiURL('proc'),
      build: process.env.VUE_APP_BUILD_TYPE,
      vendorDetailDialog: false,
      loading: false,
      isEdit: false,
      stepperElement: 1,
      wWidth: window.innerWidth,
      isAllow: false,
      dropdown: {
        // province: [],
        // city: [],
        // classification: [],
        // subClassification: [],
        averageTurnover: [
          {
            id: 1,
            name: '≤ Rp 2 Miliar (Usaha Mikro)'
          },
          {
            id: 2,
            name: '> Rp 2 Miliar – Rp 15 Miliar (Usaha Kecil)'
          },
          {
            id: 3,
            name: '> Rp 15 Miliar – Rp 50 Miliar (Usaha Menengah)'
          },
          {
            id: 4,
            name: '> Rp 50 Miliar (Usaha Besar)'
          }
        ],
        serviceCoverage: ['lokal', 'regional', 'nasional', 'internasional'],
        numberProducts: [
          {
            id: 1,
            name: '<5'
          },
          {
            id: 2,
            name: '5 - 10'
          },
          {
            id: 3,
            name: '>10'
          }
        ],
        currentEmployee: [
          {
            id: 1,
            name: '< 50 Orang'
          },
          {
            id: 2,
            name: '50 - 250 Orang'
          },
          {
            id: 3,
            name: '> 250 Orang'
          }
        ],
        companyScale: [
          {
            id: 1,
            name: 'Kecil'
          },
          {
            id: 2,
            name: 'Menengah'
          },
          {
            id: 3,
            name: 'Besar'
          },
          {
            id: 4,
            name: 'Lain - lain'
          }
        ],
        // bank: bankJson,
        documentType: []
      },
      detailData: null,
      form: null,
      pdfDialog: false,
      isPdfOpen: false,
      showPdf: false,
      pdfConfig: {
        // toolbar: false,
        secondaryToolbar: false,
        toolbar: {
          toolbarViewerRight: false
          // toolbarViewerLeft: false
        }
        // sidebar: false
      },
      value: 0,
      counter: 0,
      timer: 100,
      pdfUrl: '',
      pdfConverted: null,
      imageDialog: false,
      image: {
        width: 800,
        height: 600,
        deg: 0,
        translate: '',
        origin: 'top left'
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    documentHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tipe',
          value: 'document_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'No Dok',
          value: 'document_no',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'Tgl. Terbit',
        //   value: 'date',
        //   align: 'left',
        //   sortable: false
        // },
        // {
        //   text: 'Tgl. Expired',
        //   value: 'expire_date',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'File',
          value: 'file',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })

    // this.dropdownClassification()
    // this.dropdownProvince()
    // this.setForm()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    // 'form.classification'() {
    //   // this.form.sub_classification = null
    //   if (this.form != null && this.form.classification != null) {
    //     if (
    //       this.form.classification.sub_classification != null &&
    //       this.form.classification.sub_classification.length > 0
    //     ) {
    //       this.dropdown.subClassification =
    //         this.form.classification.sub_classification
    //     }
    //   } else {
    //     this.dropdown.subClassification = []
    //     this.form.sub_classification = null
    //   }
    // },
    // 'form.province'() {
    //   if (this.form != null && this.form.province != null) {
    //     if (
    //       this.form.province.city != null &&
    //       this.form.province.city.length > 0
    //     ) {
    //       this.dropdown.city = this.form.province.city
    //     }
    //   } else {
    //     this.dropdown.city = []
    //     this.form.city = null
    //   }
    // }
  },
  methods: {
    rotateImage(str) {
      if (this.image.deg == -270 || this.image.deg == 270) {
        this.image.deg = 0
      } else {
        if (str == 'left') {
          this.image.deg = this.image.deg - 90
        }
        if (str == 'right') {
          this.image.deg = this.image.deg + 90
        }
      }

      console.log(this.image.translate)
      if (this.image.translate == '') {
        this.image.width = 600
        this.image.height = 800
        // this.image.origin = 'top left'
        //   this.image.translate = 'translateY(-100%)'
      } else {
        this.image.width = 800
        this.image.height = 600
        // this.image.origin = ''
        //   this.image.translate = ''
      }
      // console.log(this.image.deg)
      if (
        this.image.deg == 0 ||
        this.image.deg == 180 ||
        this.image.deg == -180
      ) {
        this.image.translate = ''
        this.image.origin = ''
      }

      if (this.image.deg == -90 || this.image.deg == 270) {
        this.image.translate = 'translateX(-100%)'
        this.image.origin = 'top left'
      }
      if (this.image.deg == 90 || this.image.deg == -270) {
        this.image.translate = 'translateY(-100%)'
        this.image.origin = 'top left'
      }
    },
    closePdfDialog() {
      this.pdfDialog = false
      this.imageDialog = false
      this.isPdfOpen = false
      this.showPdf = false
      this.pdfUrl = ''
      this.pdfConverted = null
    },
    selectFile(pItem) {
      // console.log(pItem)
      // this.downloadFile(pItem)
      if (pItem.file === '' || pItem.file === null) {
        this.showMsgDialog('warning', 'File belum diupload', false)
      } else {
        this.pdfUrl = `${pItem.urlPath}${pItem.document_type.name
          .toLowerCase()
          .split(' ')
          .join('_')}/${pItem.file}`
        console.log('pdfUrl', this.pdfUrl)
        // check file type
        if (pItem.file.match(/\.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/)) {
          this.image.width = 800
          this.image.height = 600
          this.image.deg = 0
          this.image.translate = ''
          this.image.origin = 'top left'
          setTimeout(() => {
            this.imageDialog = true
          }, 300)
        } else if (!this.isPdfOpen && pItem.file.match(/\.(PDF|pdf)$/)) {
          this.viewPDF()
        } else {
          this.downloadFile(pItem)
        }
      }
    },
    viewPDF() {
      axios({
        url: this.pdfUrl,
        method: 'GET',
        responseType: 'arraybuffer'
      })
        .then((res) => {
          this.pdfConverted = res.data
          setTimeout(() => {
            if (!this.isPdfOpen) {
              this.pdfDialog = true
              this.isPdfOpen = true
              this.countDownTimer()
            }
          }, 1000)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    imgError() {
      this.pdfUrl =
        'https://e-sanqua.sanquawater.co.id/image/ecatalogue/products/photo_1/ProductPhoto-jahsors8yollrrbjwsyx7.png'
    },
    countDownTimer() {
      if (this.counter < this.timer) {
        setTimeout(() => {
          this.counter += 1
          this.value += 10
          this.countDownTimer()
        }, 1)
      } else {
        this.showPdf = true
        this.value = 0
        this.counter = 0
      }
    },
    async openHandler(pdfApp) {
      this.info = []
      const info = await pdfApp.pdfDocument
        .getMetadata()
        .catch(console.error.bind(console))

      if (!info) return
      const props = Object.keys(info.info)
      props.forEach((prop) => {
        const obj = {
          name: prop,
          value: info.info[prop]
        }
        this.info.push(obj)
      })
    },
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = 'page-fit'))
    },
    closeDetailVendorDialog() {
      this.vendorDetailDialog = false
      setTimeout(() => {
        // this.setForm()
        this.form = null
      }, 500)
    },
    openVendorDetailDialog() {
      this.detailData = this.result
      this.setDetailToForm()
      this.getDropdownDocumentType()
      setTimeout(() => {
        // this.startWatcher()
        this.vendorDetailDialog = true
      }, 500)
    },
    async getDropdownDocumentType() {
      await axios
        .get(`${this.procApi}master/document_type/drop_down?keyword=`)
        .then((res) => {
          console.log('getDropdownDocumentType', res)
          if (res.data.status_code == '00') {
            this.dropdown.documentType = res.data.data
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Dropdown document type error, Please contact an admin!'
              : 'Dropdown document type error, Please contact an admin!',
            false
          )
        })
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    // async dropdownClassification() {
    //   await axios
    //     .get(
    //       `${this.procApi}master/classification/drop_down?order_by=name&order_type=asc&keyword=`
    //     )
    //     .then((res) => {
    //       if (res.data.status_code === '00') {
    //         return (this.dropdown.classification = res.data.data)
    //       }
    //       return (this.dropdown.classification = [])
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       return (this.dropdown.classification = [])
    //     })
    // },
    // async dropdownProvince() {
    //   await axios
    //     .get(
    //       `${this.procApi}master/province/drop_down?order_by=name&order_type=asc&keyword=`
    //     )
    //     .then((res) => {
    //       if (res.data.status_code === '00') {
    //         return (this.dropdown.province = res.data.data)
    //       }
    //       return (this.dropdown.province = [])
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       return (this.dropdown.province = [])
    //     })
    // },
    // async dropdownCity() {
    //   await axios
    //     .get(
    //       `${this.procApi}master/city/drop_down?order_by=name&order_type=asc&keyword=`
    //     )
    //     .then((res) => {
    //       if (res.data.status_code === '00') {
    //         return (this.dropdown.city = res.data.data)
    //       }
    //       return (this.dropdown.city = [])
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       return (this.dropdown.city = [])
    //     })
    // },
    setDetailToForm() {
      this.setForm()
      const xData = { ...this.detailData }
      console.log('setDetailToForm>>>', xData)
      if (xData.province != null) {
        this.form.province = xData.province
        this.form.province.city = [xData.city]
        this.form.city = xData.city
        this.dropdown.city = [xData.city]
      }
      if (xData.classification != null) {
        this.form.classification = xData.classification
        this.form.classification.sub_classification = [xData.sub_classification]
        this.form.sub_classification = xData.sub_classification
        this.dropdown.subClassification = [xData.sub_classification]
      }
      if (xData.average_turnover) {
        this.form.average_turnover = this.dropdown.averageTurnover.find(
          ({ id }) => id == xData.average_turnover
        )
      }
      if (xData.number_products) {
        this.form.number_products = this.dropdown.numberProducts.find(
          ({ id }) => id == xData.number_products
        )
      }
      if (xData.current_employee) {
        this.form.current_employee = this.dropdown.currentEmployee.find(
          ({ id }) => id == xData.current_employee
        )
      }

      this.form.code = xData.code
      this.form.address = xData.address
      this.form.location_lat = xData.location_lat
      this.form.location_long = xData.location_long
      this.form.zip_code = xData.zip_code
      this.form.email = xData.email
      this.form.phone1 = xData.phone1
      this.form.phone2 = xData.phone2
      this.form.company_scale = xData.company_scale
      this.form.business_entity = xData.business_entity
      this.form.name = xData.name
      this.form.year_founded = xData.year_founded
      this.form.website = xData.website
      this.form.service_coverage = xData.service_coverage
      this.form.logo = xData.logo
      this.form.about = xData.about
      this.form.is_pkp = xData.is_pkp
      this.form.cp_name = xData.cp_name
      this.form.cp_email = xData.cp_email
      this.form.cp_phone = xData.cp_phone
      this.form.cp_position = xData.cp_position
      this.form.finance_account_name = xData.finance_account_name
      this.form.finance_account_no = xData.finance_account_no
      this.form.finance_bank_kcu = xData.finance_bank_kcu
      this.form.finance_bank_name = xData.finance_bank_name
      this.form.finance_name = xData.finance_name
      this.form.finance_phone = xData.finance_phone
      this.form.product_description = xData.product_description
      this.form.experience = xData.experience
      this.form.payment_method = xData.payment_method
      this.form.documents = xData.documents
      this.form.is_onlineshop = xData.is_onlineshop
    },
    downloadFile(xItem) {
      console.log('download>>>', xItem)
      window.open(
        `${xItem.urlPath}${xItem.document_type.name
          .toLowerCase()
          .split(' ')
          .join('_')}/${xItem.file}`,
        '_blank'
      )
    },
    showMsgDialog2(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pText,
      inputType,
      inputLabel
    ) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: inputType == undefined ? 'textarea' : inputType,
            inputLabel:
              inputLabel == undefined
                ? 'Tolong isi keterangan pada kolom dibawah sebelum submit'
                : inputLabel,
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    setForm() {
      this.form = {
        code: null,
        address: null,
        location_lat: null,
        location_long: null,
        zip_code: null,
        city: null,
        province: null,
        email: null,
        phone1: null,
        phone2: null,
        classification: null,
        sub_classification: null,
        company_scale: null,
        business_entity: null,
        name: null,
        year_founded: null,
        number_products: null,
        service_coverage: [],
        average_turnover: null,
        current_employee: null,
        logo: null,
        about: null,
        cp_name: null,
        cp_email: null,
        cp_phone: null,
        cp_position: null,
        finance_account_name: null,
        finance_account_no: null,
        finance_bank_kcu: null,
        finance_bank_name: null,
        finance_name: null,
        finance_phone: null,
        product_description: null,
        experience: null,
        documents: null,
        payment_method: null,
        is_onlineshop: null
      }
    },
    statusName(val) {
      switch (val) {
        case 0:
          return 'Need Review'
        case 1:
          return 'Review Complete'
        default:
          return '-'
      }
    },
    statusColor(val) {
      switch (val) {
        case 0:
          return 'color: orange; background-color: #4e4e4e1f;'
        case 1:
          return 'color: green; background-color: #4e4e4e1f;'
        default:
          return 'black'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-title-div2 {
  position: absolute;
  right: 0;
  top: 5px;
  padding: 5px 30px;
  min-width: 200px;
  .card-title-div2-name {
    margin: 0;
    font-size: 16px;
    font-weight: bolder;
    text-transform: uppercase;
  }
}
</style>
